import { Component, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { T2CardComponent } from '../t2-card/t2-card.component';
import { EventEmitter } from '@angular/forms/src/facade/async';
import { AuthenticationService } from '../../../pages/login/authentication.service';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { UsersService } from '../../../pages/users/users.service';
import { TripNotificationsService } from 'app/services/trip-notifications.service';
import { getCurrentUser } from 'app/utils/helpers';
import { environment } from 'environments/environment';
import { T2ThemeService } from 'app/trip2-theme/t2-theme.service';

declare const $: any;
declare const Push: any;

@Component({
  selector: 'app-t2-header-main',
  templateUrl: './t2-header-main.component.html',
  styleUrls: ['./t2-header-main.component.scss']
})
export class T2HeaderMainComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  protected profile: any = {
    names: '',
    modifiedon: '',
    avatar: '',
    email: ''
  };
  public active;
  pageTitle: string;
  changePicture: false;
  rememberReload = undefined;
  timeRememberReload = 5;
  hasSupport = false;

  currentUser = JSON.parse(localStorage.getItem('currentUser'));


  @Output() EmitterClickLogo: EventEmitter<any> = new EventEmitter<any>();
  @Output() EmitterLogout: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild('modalChangePassword') modalChangePassword: T2CardComponent;
  @ViewChild('modalSupport') modalSupport: T2CardComponent;
  @ViewChild('modalChangePicture') modalChangePicture: T2CardComponent;
  @ViewChild('t2help') t2help: T2CardComponent;

  constructor(
    private userService: UsersService,
    private _authenticationService: AuthenticationService,
    private router: Router,
    private titleService: Title,
    private tripNotificationsService: TripNotificationsService,
    private t2ThemeService: T2ThemeService

  ) {
    //this.verifyVersion();
  }

  /**
   * @name resultChangePassword
   * @description Verificar el evento de cambio de password para cerrar la ventana
   * @param event
   */
  resultChangePassword (event) {
    if (event.closed) {
      this.modalChangePassword.close();
    }
  }

  clickLogo(event) {
    return this.EmitterClickLogo.emit(event);
  }

  // openSupportCenter() {
  //   this.modalSupport.open();
  // }
  /**
   * @name logout
   * @description Cerrar sesion
   * @return EventEmmiter
   */
  logout() {
    this.tripNotificationsService.closeSignalR();
    this._authenticationService.logout().subscribe();
      localStorage.removeItem('currentUser');
      this.router.navigate(['/login'], { replaceUrl: true });
      return this.EmitterLogout.emit(true);
  }

  ngOnInit() {
    this.subscriptions.push(
      this.userService.currentUserInformation$.subscribe({
        next: (currentUserData) => {
          if (currentUserData) {
            this.profile.names = currentUserData.fullname;
            this.profile.modifiedon = currentUserData.modifiedon;
            this.profile.avatar = currentUserData.userphoto;
            this.profile.email = currentUserData.emailaddress;
            if (currentUserData.reenterpassword) {
              this.modalChangePassword.open();
            }
          }
        }
      }),
      this.t2ThemeService.hasSupport$.subscribe({
        next: (value) => {
          if (value) {
            this.hasSupport = value;
          }
        },
      })
    );

    this.router.events.filter((event: any ) => event instanceof NavigationEnd)
      .subscribe(() => {
        let root = this.router.routerState.snapshot.root;
        while (root) {
          if (root.children && root.children.length) {
            root = root.children[0];
          } else if (root.data && root.data['title']) {
            this.pageTitle = root.data['title'];
            /**
             * @todo Cambiar en el futuro
             */
            $('#main-header .page-title').html(root.data['title']);
            this.titleService.setTitle(root.data['title']);
            return;
          }else {
            return;
            }
        }
      });
  }


  /**
   * @name mouseLeave
   * @description Al salir del menu
   */
  mouseLeave () {
    this.active = false;
  }

  onActionProfile(event) {
    this.modalChangePicture.viewProgressBar(event.onSave);
    if (event.isUpdate) {
      this. profile.avatar = event.img;
    }
  }
  
  openModalSupport() {
    if (this.t2help) {
      this.t2help.open();
    }
  }

  refresh() {
    location.reload();
  }

  get matchVersion(): boolean {
    const user = getCurrentUser();
    return !!(user && user.localversion === environment.version);
  }

  verifyVersion() {
    try {
      if (!this.matchVersion) {
        Push.create('Important announcement', {
          body: 'Your current version is different from the server version, please reload the application.',
          icon: 'assets/images/logo.png',
          requireInteraction: true,
          tag: '#version',
          onClick: function () {
            window.focus();
            this.close();
          }
        });
      }
    } catch (error) {
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

}



// WEBPACK FOOTER //
// ./src/app/trip2-theme/components/t2-header-main/t2-header-main.component.ts